package com.iptvplayer.shared.db

import app.cash.sqldelight.Query
import app.cash.sqldelight.TransacterImpl
import app.cash.sqldelight.db.QueryResult
import app.cash.sqldelight.db.SqlCursor
import app.cash.sqldelight.db.SqlDriver
import kotlin.Any
import kotlin.Long
import kotlin.String

public class WatchHistoryQueries(
  driver: SqlDriver,
) : TransacterImpl(driver) {
  public fun <T : Any> selectAll(`value`: Long, mapper: (
    id: String,
    userId: String,
    contentId: String,
    contentType: String,
    contentName: String,
    contentLogoUrl: String?,
    streamUrl: String,
    resumePositionMs: Long,
    durationMs: Long?,
    lastWatchedAt: Long,
  ) -> T): Query<T> = SelectAllQuery(value) { cursor ->
    mapper(
      cursor.getString(0)!!,
      cursor.getString(1)!!,
      cursor.getString(2)!!,
      cursor.getString(3)!!,
      cursor.getString(4)!!,
      cursor.getString(5),
      cursor.getString(6)!!,
      cursor.getLong(7)!!,
      cursor.getLong(8),
      cursor.getLong(9)!!
    )
  }

  public fun selectAll(value_: Long): Query<WatchHistoryEntity> = selectAll(value_) { id, userId,
      contentId, contentType, contentName, contentLogoUrl, streamUrl, resumePositionMs, durationMs,
      lastWatchedAt ->
    WatchHistoryEntity(
      id,
      userId,
      contentId,
      contentType,
      contentName,
      contentLogoUrl,
      streamUrl,
      resumePositionMs,
      durationMs,
      lastWatchedAt
    )
  }

  public fun <T : Any> selectByContentId(contentId: String, mapper: (
    id: String,
    userId: String,
    contentId: String,
    contentType: String,
    contentName: String,
    contentLogoUrl: String?,
    streamUrl: String,
    resumePositionMs: Long,
    durationMs: Long?,
    lastWatchedAt: Long,
  ) -> T): Query<T> = SelectByContentIdQuery(contentId) { cursor ->
    mapper(
      cursor.getString(0)!!,
      cursor.getString(1)!!,
      cursor.getString(2)!!,
      cursor.getString(3)!!,
      cursor.getString(4)!!,
      cursor.getString(5),
      cursor.getString(6)!!,
      cursor.getLong(7)!!,
      cursor.getLong(8),
      cursor.getLong(9)!!
    )
  }

  public fun selectByContentId(contentId: String): Query<WatchHistoryEntity> =
      selectByContentId(contentId) { id, userId, contentId_, contentType, contentName,
      contentLogoUrl, streamUrl, resumePositionMs, durationMs, lastWatchedAt ->
    WatchHistoryEntity(
      id,
      userId,
      contentId_,
      contentType,
      contentName,
      contentLogoUrl,
      streamUrl,
      resumePositionMs,
      durationMs,
      lastWatchedAt
    )
  }

  public fun insert(
    id: String,
    userId: String,
    contentId: String,
    contentType: String,
    contentName: String,
    contentLogoUrl: String?,
    streamUrl: String,
    resumePositionMs: Long,
    durationMs: Long?,
    lastWatchedAt: Long,
  ) {
    driver.execute(-1_454_469_578, """
        |INSERT OR REPLACE INTO WatchHistoryEntity(id, userId, contentId, contentType, contentName, contentLogoUrl, streamUrl, resumePositionMs, durationMs, lastWatchedAt)
        |VALUES (?, ?, ?, ?, ?, ?, ?, ?, ?, ?)
        """.trimMargin(), 10) {
          bindString(0, id)
          bindString(1, userId)
          bindString(2, contentId)
          bindString(3, contentType)
          bindString(4, contentName)
          bindString(5, contentLogoUrl)
          bindString(6, streamUrl)
          bindLong(7, resumePositionMs)
          bindLong(8, durationMs)
          bindLong(9, lastWatchedAt)
        }
    notifyQueries(-1_454_469_578) { emit ->
      emit("WatchHistoryEntity")
    }
  }

  public fun deleteByContentId(contentId: String) {
    driver.execute(-282_356_075, """DELETE FROM WatchHistoryEntity WHERE contentId = ?""", 1) {
          bindString(0, contentId)
        }
    notifyQueries(-282_356_075) { emit ->
      emit("WatchHistoryEntity")
    }
  }

  public fun deleteAll() {
    driver.execute(1_847_672_665, """DELETE FROM WatchHistoryEntity""", 0)
    notifyQueries(1_847_672_665) { emit ->
      emit("WatchHistoryEntity")
    }
  }

  private inner class SelectAllQuery<out T : Any>(
    public val `value`: Long,
    mapper: (SqlCursor) -> T,
  ) : Query<T>(mapper) {
    override fun addListener(listener: Query.Listener) {
      driver.addListener("WatchHistoryEntity", listener = listener)
    }

    override fun removeListener(listener: Query.Listener) {
      driver.removeListener("WatchHistoryEntity", listener = listener)
    }

    override fun <R> execute(mapper: (SqlCursor) -> QueryResult<R>): QueryResult<R> =
        driver.executeQuery(490_406_504,
        """SELECT WatchHistoryEntity.id, WatchHistoryEntity.userId, WatchHistoryEntity.contentId, WatchHistoryEntity.contentType, WatchHistoryEntity.contentName, WatchHistoryEntity.contentLogoUrl, WatchHistoryEntity.streamUrl, WatchHistoryEntity.resumePositionMs, WatchHistoryEntity.durationMs, WatchHistoryEntity.lastWatchedAt FROM WatchHistoryEntity ORDER BY lastWatchedAt DESC LIMIT ?""",
        mapper, 1) {
      bindLong(0, value)
    }

    override fun toString(): String = "WatchHistory.sq:selectAll"
  }

  private inner class SelectByContentIdQuery<out T : Any>(
    public val contentId: String,
    mapper: (SqlCursor) -> T,
  ) : Query<T>(mapper) {
    override fun addListener(listener: Query.Listener) {
      driver.addListener("WatchHistoryEntity", listener = listener)
    }

    override fun removeListener(listener: Query.Listener) {
      driver.removeListener("WatchHistoryEntity", listener = listener)
    }

    override fun <R> execute(mapper: (SqlCursor) -> QueryResult<R>): QueryResult<R> =
        driver.executeQuery(1_171_577_508,
        """SELECT WatchHistoryEntity.id, WatchHistoryEntity.userId, WatchHistoryEntity.contentId, WatchHistoryEntity.contentType, WatchHistoryEntity.contentName, WatchHistoryEntity.contentLogoUrl, WatchHistoryEntity.streamUrl, WatchHistoryEntity.resumePositionMs, WatchHistoryEntity.durationMs, WatchHistoryEntity.lastWatchedAt FROM WatchHistoryEntity WHERE contentId = ?""",
        mapper, 1) {
      bindString(0, contentId)
    }

    override fun toString(): String = "WatchHistory.sq:selectByContentId"
  }
}
